import { render, staticRenderFns } from "./AzureMD.vue?vue&type=template&id=357f6aab&scoped=true"
import script from "./AzureMD.vue?vue&type=script&lang=js"
export * from "./AzureMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357f6aab",
  null
  
)

export default component.exports